import Experiments from '@bridebook/toolbox/src/ab-testing/ab-testing';
import type { CohortNames, Experiment } from '@bridebook/toolbox/src/ab-testing/lib/types';

const SALT = '3b3652a7ca980aa1f7c9a31b44b230f7';

export function getExperimentCohort(abTest: Experiment, userId: string): CohortNames {
  const experiments = new Experiments(
    {
      version: '1.0',
      experiments: [abTest],
      salt: SALT,
    },
    userId,
    { id: userId },
  );
  return experiments.getCohort(abTest.id) as CohortNames;
}
